module.exports = __webpack_public_path__ + "img/chamada-evento.e88047c9.png";